import React from 'react'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import ProTrackName from 'app/components/ProTrackName/ProTrackName'
import './styles.scss'

const UserProTrackStartBlock = ({ t, startDate, proTrackName, show }) => {
  return (
    show ? (
      <div className="user-protrack-start-block">
        {t('Your ProTrack')}{' '}
        <ProTrackName proTrackName={proTrackName} className="user-protrack-start-block__protrack-name" />{' '}
        {t('will start on', { date: moment(startDate).format('dddd, MMMM Do') })}
      </div>
    ) : null
  )
}

export default withTranslation('user')(UserProTrackStartBlock)
